import React from 'react';
import { Select, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { shopProductsSortOptions } from '../../shared/constants/shopProductsSortOptions';
import { setShopSortingAction } from '../../store/shopActions';

const useStyle = makeStyles(theme => ({
  select: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    padding: '13px 15px',
    textTransform: 'uppercase',
    fontSize: '0.8125rem',
    fontWeight: 500,

    '&:focus': {
      background: theme.palette.primary.main,
      borderRadius: 4,
    },
  },
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

const ShopSortSelect = () => {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();

  const sortBy = useSelector(({ shop }) => shop.sortBy);

  const handleSortingChange = event => {
    dispatch(setShopSortingAction({ sortBy: event.target.value }));
  };

  return (
    <Select value={sortBy} onChange={handleSortingChange} label="Sort" classes={classes}>
      {Object.keys(shopProductsSortOptions).map(sortOption => (
        <MenuItem key={sortOption} value={sortOption}>
          {t('Sort by')} {sortOption}
        </MenuItem>
      ))}
    </Select>
  );
};

export { ShopSortSelect };
